















import { computed, defineComponent, onUnmounted, ref, getCurrentInstance } from '@vue/composition-api';
import dayjs from 'dayjs';
import i18n, { i18n_t } from '@/locales/i18n';
import { httpUrl } from '@/renderer/scripts/http';
import tips from '@/renderer/scripts/utils/tips';
import passwordHandler from '@/renderer/components/user/compositions/passwordHandler';
export default defineComponent({
  name: 'userConfigBar',
  props: {
    userInfo: {
      type: Object,
      required: true,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const { getResetToken, createResetToken, copyResetPasswordUrl } = passwordHandler();
    const token = ref('');
    const expireTime = ref('');
    const expireCountTime = ref('');
    const url = computed(() =>
      token.value ? `${httpUrl.webUrl}/web/resetPassword/${encodeURIComponent(token.value)}` : '',
    );
    let timer: number | undefined = undefined;
    const methods = {
      async init() {
        const tokenInfo = await getResetToken(props.userInfo.id as number);
        if (!tokenInfo) return;
        // 已经重置过
        if (tokenInfo.isModified) {
          token.value = '';
          return;
        }
        token.value = tokenInfo.token;
        expireTime.value = tokenInfo.expireTime;
        methods.countTime(tokenInfo.expireTime);
      },
      // 倒计时
      countTime(time: string) {
        methods.clearTimer();
        const thisT = new Date(time).getTime();
        const fn = () => {
          const nowTime = new Date().getTime();
          // 到期后
          if (nowTime >= thisT) {
            methods.clear();
            methods.init();
            return;
          }
          expireCountTime.value = dayjs.duration(thisT - nowTime).format('HH:mm:ss');
        };
        fn();
        timer = window.setInterval(() => {
          fn();
        }, 1000);
      },
      clear() {
        token.value = '';
        expireTime.value = '';
        methods.clearTimer();
      },
      clearTimer() {
        if (timer) {
          window.clearInterval(timer);
          timer = undefined;
        }
      },
      async createResetUrl() {
        token.value = await createResetToken(props.userInfo.id as number);
        if (token.value) {
          tips.success(i18n_t('生成成功'));
        }
        methods.init();
      },
      copyResetUrl() {
        const formatTime = dayjs(expireTime.value).format('YYYY-MM-DD HH:mm:ss');
        copyResetPasswordUrl({
          type: 'resetPassword',
          url: url.value,
          nickname: props.userInfo.nickname,
          accountName: props.userInfo.accountName,
          formatTime,
        });
      },
      submit() {
        context.emit('submit');
      },
    };
    methods.init();
    onUnmounted(() => {
      methods.clear();
    });
    return {
      url,
      expireTime,
      expireCountTime,
      ...methods,
    };
  },
});
